import { lazyWithPreload } from 'react-lazy-with-preload';

const AuthLayout = lazyWithPreload(() => import('./layouts/auth/AuthLayout'));
const PIFAuthLayout = lazyWithPreload(() => import('./pages/login-pif/layouts/auth/PIFAuthLayout'));

const LoginPage = lazyWithPreload(() => import('./pages/login/LoginPage'));
const TokenLoginPage = lazyWithPreload(() => import('./pages/token-login/TokenLoginPage'));
const PIFLoginPage = lazyWithPreload(() => import('./pages/login-pif/PIFLoginPage'));
const ChooseAccountPage = lazyWithPreload(() => import('./pages/choose-account/ChooseAccountPage'));
const ForgotPasswordPage = lazyWithPreload(() => import('./pages/forgot-password/ForgotPasswordPage'));
const VerifyOtpPage = lazyWithPreload(() => import('./pages/verify-otp/VerifyOtpPage'));
const ResetPasswordPage = lazyWithPreload(() => import('./pages/reset-password/ResetPasswordPage'));
const VerifyEmailOtpPage = lazyWithPreload(() => import('./pages/verify-email-otp/VerifyEmailOtpPage'));
const TrustBrowserPage = lazyWithPreload(() => import('./pages/trust-browser/TrustBrowserPage'));

const Routes = [
    {
        path: '',
        element: <AuthLayout />,
        children: [
            {
                index: true,
                element: <LoginPage />,
            },
            {
                path: '/token-login',
                element: <TokenLoginPage />,
            },

            {
                path: '/otp-verification',
                element: <VerifyEmailOtpPage />,
            },
            {
                path: '/trust-browser',
                element: <TrustBrowserPage />,
            },
            {
                path: '/choose-account',
                element: <ChooseAccountPage />,
            },
            {
                path: 'forgot-password',
                element: <ForgotPasswordPage />,
            },
            {
                path: 'verify-otp',
                element: <VerifyOtpPage />,
            },
            {
                path: 'reset-password',
                element: <ResetPasswordPage />,
            },
        ],
    },
    {
        path: 'pif',
        element: <PIFAuthLayout />,
        children: [
            {
                index: true,
                element: <PIFLoginPage />,
            },
        ],
    },
];

export default Routes;
